export default __webpack_public_path__ + "static/Крысиные бега_11-acc216b02f48438fe59db68a8329ca1f.jpg";